import { render, staticRenderFns } from "./TeamReview.vue?vue&type=template&id=d7351bda&"
import script from "./TeamReview.vue?vue&type=script&lang=js&"
export * from "./TeamReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports